module.exports = __webpack_public_path__ + "static/media/onlyTextLogo.02d6903b.png";